import { Status } from '../progress-tracker/progress-tracker.component';

const STATUS_KEY = 'SMS_REGULATION.COMMON.STATUS';

/**
 * i18n key for the approved-state banner message that corresponds to the 4th-step status.
 * Returns null when the step-4 status doesn't drive the banner (e.g. NotStarted).
 */
export function getPhoneProvisioningMessageKey(stageStatus: Status): string | null {
  switch (stageStatus) {
    case Status.InProgress:
      return `${STATUS_KEY}.NUMBER_REQUESTING_MESSAGE`;
    case Status.Completed:
      return `${STATUS_KEY}.NUMBER_ACTIVE_MESSAGE`;
    case Status.Failed:
      return `${STATUS_KEY}.NUMBER_FAILED_MESSAGE`;
    case Status.NotStarted:
    default:
      return null;
  }
}
